import React, { useState, useEffect, Fragment } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import { useForm } from "react-hook-form";
import axiosConfig from "../../services/axiosConfig";
import SweetAlert from 'sweetalert2';
import setHeader from "../../components/Functions/setHeader";
import { size } from "lodash";
import LoadingComponent from "../../components/common/LoadingComponent";
import NoDataHandler from "../../components/common/NoDataHandler";


const Groups = () => {
    const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm();
    const [data, setData] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editId, setEditId] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        getData();
    }, []);



    const getData = () => {
        setLoading(true);
        setData([]); // Reset data before fetching new data

        axiosConfig.get("group-list", setHeader())
            .then((res) => {
                setData(res.data.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onSubmit = data => {
        if (data !== '') {

            data.status = data.status ? 1 : 0;

            if (editMode) {
                axiosConfig.post(`update-group/${editId}`, data, setHeader()).then((res) => {
                     if (res.data.error && res.data.messages === 'Group name already exists!') {
                        SweetAlert.fire({
                            title: "Error",
                            text: "Group name already exists!",
                            icon: "warning",
                        });
                        return; // STOP here
                    }
                    if (!res.data.error) {
                        SweetAlert.fire({ title: "Success", text: "Updated Successfully", icon: "success" });
                        reset();
                        setEditMode(false);
                        setEditId(null);
                        getData();
                    } else {
                        SweetAlert.fire({ title: "Oops!", text: "Failed to update. Try again!", icon: "error" });
                    }
                }).catch((error) => console.log(error));
            } else {

                axiosConfig.post("insert-group", data, setHeader()).then((res) => {
                    if (res.data.error && res.data.messages === 'Exist a Group in this name !') {
                        SweetAlert.fire({
                            title: "Error",
                            text: "Group name already exists!",
                            icon: "warning",
                        });
                        return; // STOP here
                    }

                    if (!res.data.error) {
                        SweetAlert.fire({ title: "Success", text: "Inserted Successfully", icon: "success" });
                        // Reset the form fields
                        reset();
                        getData();

                    } else {
                        SweetAlert.fire({ title: "Oops!", text: "Failed to insert. Try again!", icon: "error" });
                    }

                }).catch((error) => {
                    console.log(error);
                });
            }

        } else {
            errors.showMessages();
        }
    };

    const editData = (id) => {
        const groupToEdit = data.find((item) => item.id === id);
        if (groupToEdit) {
            setEditMode(true);
            setEditId(id);

            // Populate form fields
            setValue("group", groupToEdit.group_name);
            setValue("desc", groupToEdit.description);
            setValue("status", groupToEdit.status == 1);
            setValue("group_order", groupToEdit.group_order || "");

        }
    };

    const DeleteData = (id) => {
        SweetAlert.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ok',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                axiosConfig.get(`delete-group/${id}`, setHeader())
                    .then((res) => {
                        if (!res.data.error) {
                            SweetAlert.fire({
                                title: "Success",
                                text: res.data.messages,
                                icon: "success",
                            });
                            getData(); // Refresh the list
                        } else {
                            SweetAlert.fire({
                                title: "Oops!",
                                text: res.data.messages,
                                icon: "error",
                            });
                        }
                    })
                    .catch((error) => {
                        console.error("Error deleting data:", error);
                        SweetAlert.fire({
                            title: "Error",
                            text: "An error occurred while deleting the data.",
                            icon: "error",
                        });
                    });
            }
        });
    };
    if (loading) {
        return (
            <LoadingComponent />
        );
    }
    //  if (data.length === 0) {
    //     return <NoDataHandler title='No Groups Fount' />;
    //   }

    return (
        <Fragment>
            <Breadcrumb title="Groups" parent="Masters" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-5">
                        <div className="card">
                            <div className="card-body">
                                <form className="needs-validation" noValidate="" onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-row">
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="validationCustom01">Group <span style={{ color: 'red', fontSize: '21px' }}>*</span></label>
                                            <input className="form-control" name="group" type="text" placeholder="Group" {...register('group', { required: true })} />
                                            <span>{errors.group && 'Group is required'}</span>
                                            <div className="valid-feedback">{"Looks good!"}</div>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label>Description</label>
                                            <textarea className="form-control" rows="3" cols="5" name="desc" placeholder="Description..." {...register('desc', { required: false })}></textarea>
                                        </div>
                                        <div className="col-md-12 mb-3">
                                            <label htmlFor="group_order">Group Order</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="group_order"
                                                placeholder="Enter display order"
                                                {...register("group_order", { required: false })}
                                            />
                                        </div>


                                        <div className="col-md-12 checkbox checkbox-solid-primary mb-3">
                                            <input id="solid3" type="checkbox" value="1" name="status" {...register('status', { required: false })} defaultChecked />
                                            <label htmlFor="solid3">Active</label>
                                        </div>
                                    </div>
                                    <button className="btn btn-primary" type="submit">{editMode == true ? 'Update' : 'Save'}</button>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-7">
                        <div className="table-responsive">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th scope="col">{"#"}</th>
                                        <th scope="col">{"Order"}</th>
                                        <th scope="col">{"Group"}</th>
                                        <th scope="col">{"Status"}</th>
                                        <th scope="col">{"Action"}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => {
                                        return (
                                            <tr key={index}>
                                                <th scope="row">{index + 1}</th>
                                                <th scope="row">{item.group_order}</th>
                                                <td>{item.group_name}</td>
                                                <td>{item.status == 1 ? "Active" : "Inactive"}</td>
                                                <td>
                                                    <button title="Edit" className="btn btn-xs btn-outline-success" onClick={(e) => { editData(item.id) }}>
                                                        Edit
                                                    </button>&nbsp;
                                                    <button title="Delete" className="btn btn-xs btn-outline-danger" onClick={(e) => DeleteData(item.id)}>
                                                        Delete
                                                    </button>

                                                </td>
                                            </tr>
                                        );
                                    })}

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </div>

        </Fragment>
    );
};

export default Groups;